import { render } from "./MerchItem.vue?vue&type=template&id=8d55182c"
import script from "./MerchItem.vue?vue&type=script&lang=js"
export * from "./MerchItem.vue?vue&type=script&lang=js"

import exportComponent from "/Users/davidebertuzzi/WebstormProjects/procremonafrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__